import React from 'react'
import TopTab from './TopTab'
import OrderTable from './OrderTable'
import { Button, Input, Menu, MenuHandler, MenuList, MenuItem } from '@material-tailwind/react'
import { CiSearch } from "react-icons/ci";
import { FaPlus, FaChevronDown, FaFilePdf, FaPrint, FaTruck, FaBarcode } from "react-icons/fa";
import { TrashIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import { ExportJsonCsv } from 'react-export-json-csv';
import { SiMicrosoftexcel } from "react-icons/si";
import { FiCalendar } from "react-icons/fi";
import Loader from '../Loader';
const Orders = ({ orderList, activeTab, setActiveTab, handlePartnerModal, setOrderID, unifiedSearch, filteredOrderList, deleteOrder, dateRange, setDateRange, startDate, endDate, selectedDatePreset, setSelectedDatePreset, fetchByDate, clearDate, csvOrders, csvHeaders, isAdmin, onOpenMisModal, selectedOrderIds, onClearSelection, onBulkDelete, onBulkPrint, onBulkShip, onBulkWaybillDownload, onBulkBarcodeDownload, bulkPrinting, setLoadingOrder, loadingOrder, setSearch, search, searchQuery, currentPage, setCurrentPage, setItemOffset, fetchAdminOrders, loadingMore, toggleOrderSelection, toggleSelectAllVisible, rowsPerPage, setRowsPerPage, refreshOrders }) => {
  const hasDateRange = !!startDate && !!endDate
  const hasActiveDateFilter = hasDateRange || !!selectedDatePreset
  const deliveredCount = orderList?.filter((item) => String(item?.orderStatus || '').toLowerCase() === 'delivered').length || 0
  const inTransitCount = orderList?.filter((item) => String(item?.orderStatus || '').toLowerCase() === 'in-transit').length || 0
  const outForDeliveryCount = orderList?.filter((item) => String(item?.orderStatus || '').toLowerCase() === 'out for delivery').length || 0
  const selectedOrders = (orderList || []).filter((item) => selectedOrderIds?.includes(item?.id))
  const canBulkShip = selectedOrders.length > 0 && selectedOrders.every((item) => String(item?.orderStatus || '').toLowerCase() === 'new')
  const statCards = [
    { label: 'Total', value: orderList?.length || 0, note: `${filteredOrderList?.length || 0} visible now` },
    { label: 'In Transit', value: inTransitCount, note: 'Currently moving' },
    { label: 'Out for Delivery', value: outForDeliveryCount, note: 'Final delivery stage' },
    { label: 'Delivered', value: deliveredCount, note: 'Closed shipments' },
  ]
  return (
    <div className='min-h-[105vh] mx-3 pb-6' >
      {/* Header Section */}
      <div className='mt-3 mb-4' >
        <div className='flex flex-col gap-4'>
          <div className='flex flex-wrap items-center gap-2'>
            <div className='relative min-w-[260px] flex-1'>
              <Input
                type="search"
                onChange={unifiedSearch}
                placeholder="Search by order ID, LR no, client, consignee, tracking..."
                containerProps={{
                  className: "min-w-full",
                }}
                className="!border-0 h-11 rounded-full bg-white pl-10 pr-4 text-[13px] shadow-[0_6px_20px_rgba(15,23,42,0.04),inset_0_0_0_1px_rgba(148,163,184,0.22)] placeholder:text-slate-400 focus:!border-0 focus:shadow-[0_10px_22px_rgba(249,115,22,0.08),inset_0_0_0_2px_rgba(249,115,22,0.22)]"
                labelProps={{
                  className: "before:content-none after:content-none",
                }}
              />
              <div className="!absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400">
                <CiSearch className='w-4 h-4' />
              </div>
            </div>
            <div className='flex flex-wrap items-center gap-2'>
                <div className='flex h-11 min-w-[290px] items-center gap-2 rounded-full bg-white px-3 shadow-[0_6px_20px_rgba(15,23,42,0.04),inset_0_0_0_1px_rgba(148,163,184,0.22)]'>
                  <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#fff1e8] text-[#f97316]'>
                    <FiCalendar className='h-3.5 w-3.5' />
                  </div>
                  <div className='min-w-0 flex-1'>
                    <p className='text-[9px] font-[GilroyBold] uppercase tracking-[0.16em] text-slate-400'>Booking Date</p>
                    <DatePicker
                      className='w-full bg-transparent text-[12px] font-[GilroyMedium] text-slate-700 placeholder:text-slate-400 focus:outline-none'
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(update) => {
                        setSelectedDatePreset('');
                        setDateRange(update);
                      }}
                      placeholderText="Select date range"
                    />
                  </div>
                  <div className='flex shrink-0 items-center gap-1.5'>
                    <Button
                      size='sm'
                      disabled={!hasActiveDateFilter}
                      className='rounded-full bg-[#f97316] px-3.5 py-2 text-[10px] text-white shadow-[0_10px_22px_rgba(249,115,22,0.18)] hover:bg-[#ea580c] disabled:bg-slate-200 disabled:text-slate-400'
                      onClick={fetchByDate}
                    >
                      Apply
                    </Button>
                    {hasActiveDateFilter && (
                      <Button
                        size='sm'
                        className='rounded-full border border-slate-200 bg-white px-3 py-2 text-[10px] text-slate-700 shadow-none hover:bg-slate-50'
                        onClick={clearDate}
                      >
                        Clear
                      </Button>
                    )}
                  </div>
                </div>

                <div className='flex h-11 min-w-[170px] items-center gap-2 rounded-full bg-white px-3.5 shadow-[0_6px_20px_rgba(15,23,42,0.04),inset_0_0_0_1px_rgba(148,163,184,0.22)]'>
                  <span className='text-[12px] font-[GilroyMedium] text-slate-500'>Quick Date</span>
                  <select
                    value={selectedDatePreset}
                    onChange={(event) => {
                      const nextPreset = event.target.value
                      setSelectedDatePreset(nextPreset)
                      setDateRange([null, null])
                    }}
                    className='min-w-0 flex-1 bg-transparent text-[12px] font-[GilroyBold] text-slate-700 focus:outline-none'
                  >
                    <option value="">Select</option>
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="lastWeek">Last Week</option>
                    <option value="lastMonth">Last Month</option>
                    <option value="lastYear">Last Year</option>
                  </select>
                </div>

                <Menu>
                  <MenuHandler>
                    <Button className='flex h-10 items-center gap-2 rounded-xl bg-[#0f172a] px-4 py-2 text-[12px] font-[GilroyBold] text-white shadow-[0_12px_24px_rgba(15,23,42,0.12)] hover:bg-[#1e293b]'>
                      <FaPlus className='h-3 w-3' />
                      Quick Actions
                      <FaChevronDown className='h-2.5 w-2.5' />
                    </Button>
                  </MenuHandler>
                  <MenuList>
                    <Link to="/create-order">
                      <MenuItem className='flex items-center gap-2'>
                        <FaPlus className='w-4 h-4' />
                        Create Order
                      </MenuItem>
                    </Link>
                    <Link to="/bulk-order-upload">
                      <MenuItem className='flex items-center gap-2'>
                        <FaPlus className='w-4 h-4' />
                        Create Bulk Order
                      </MenuItem>
                    </Link>
                    <Link to="/bulk-waybill-download">
                      <MenuItem className='flex items-center gap-2'>
                        <FaFilePdf className='w-4 h-4' />
                        Bulk Download Waybill
                      </MenuItem>
                    </Link>
                    {isAdmin ? (
                      <MenuItem className='flex items-center gap-2' onClick={onOpenMisModal}>
                        <SiMicrosoftexcel className='w-4 h-4' />
                        <span className='flex items-center gap-2'>
                          Download MIS
                        </span>
                      </MenuItem>
                    ) : (
                      <MenuItem className='flex items-center gap-2'>
                        <SiMicrosoftexcel className='w-4 h-4' />
                        <ExportJsonCsv headers={csvHeaders} items={csvOrders} fileTitle="MIS_Report">
                          <span className='flex items-center gap-2'>
                            Download MIS
                          </span>
                        </ExportJsonCsv>
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
                <Button
                  size="sm"
                  className='flex h-10 items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-[10px] text-slate-700 shadow-[0_10px_20px_rgba(15,23,42,0.05)] hover:bg-slate-50'
                  onClick={onBulkPrint}
                  disabled={!selectedOrderIds?.length || bulkPrinting}
                >
                  <FaPrint className='h-3 w-3' />
                  {bulkPrinting ? 'Printing...' : 'Print Selected'}
                </Button>
                {isAdmin && (
                  <Button
                    size="sm"
                    className='flex h-10 items-center gap-2 rounded-full bg-[#ef4444] px-3.5 py-2 text-[10px] text-white shadow-[0_10px_24px_rgba(239,68,68,0.22)] hover:bg-[#dc2626]'
                    onClick={onBulkDelete}
                    disabled={!selectedOrderIds?.length}
                  >
                    <TrashIcon className='h-3.5 w-3.5' />
                    Delete Selected
                  </Button>
                )}
            </div>
          </div>
          <div className='grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4'>
            {statCards.map((card) => (
              <div key={card.label} className='rounded-[24px] border border-slate-200 bg-white px-5 py-4 shadow-[0_12px_28px_rgba(15,23,42,0.05)]'>
                <p className='text-sm font-[GilroyBold] text-slate-600'>{card.label}</p>
                <p className='mt-3 text-[2rem] leading-none font-[GilroyBold] tracking-[-0.05em] text-slate-950'>{card.value}</p>
                <p className='mt-3 inline-flex rounded-full bg-[#fff4ed] px-3 py-1 text-xs font-[GilroyBold] text-[#f97316]'>{card.note}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {loadingOrder ? (
        <div className='flex justify-center items-center h-full'>
          <Loader />
        </div>
      ) : (
        <>
          <TopTab orderList={orderList} activeTab={activeTab} setActiveTab={setActiveTab} />
          {selectedOrderIds?.length > 0 && (
            <div className='mb-4 flex flex-wrap items-center gap-2 rounded-[24px] border border-slate-200 bg-white px-4 py-3 shadow-[0_12px_28px_rgba(15,23,42,0.05)]'>
              <p className='mr-2 text-[12px] font-[GilroyBold] uppercase tracking-[0.14em] text-slate-500'>
                {selectedOrderIds.length} selected
              </p>
              {canBulkShip && (
                <Button
                  size="sm"
                  className='flex h-10 items-center gap-2 rounded-full bg-[#0f172a] px-3.5 py-2 text-[10px] text-white shadow-[0_10px_22px_rgba(15,23,42,0.18)] hover:bg-[#1e293b]'
                  onClick={onBulkShip}
                >
                  <FaTruck className='h-3.5 w-3.5' />
                  Ship Orders
                </Button>
              )}
              <Button
                size="sm"
                className='flex h-10 items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-[10px] text-slate-700 shadow-[0_10px_20px_rgba(15,23,42,0.05)] hover:bg-slate-50'
                onClick={onBulkWaybillDownload}
              >
                <FaFilePdf className='h-3.5 w-3.5' />
                Download Waybill
              </Button>
              <Button
                size="sm"
                className='flex h-10 items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-[10px] text-slate-700 shadow-[0_10px_20px_rgba(15,23,42,0.05)] hover:bg-slate-50'
                onClick={onBulkBarcodeDownload}
              >
                <FaBarcode className='h-3.5 w-3.5' />
                Download Barcode
              </Button>
              <Button
                size="sm"
                className='flex h-10 items-center gap-2 rounded-full border border-slate-200 bg-white px-3.5 py-2 text-[10px] text-slate-700 shadow-[0_10px_20px_rgba(15,23,42,0.05)] hover:bg-slate-50'
                onClick={onBulkPrint}
                disabled={bulkPrinting}
              >
                <FaPrint className='h-3.5 w-3.5' />
                {bulkPrinting ? 'Printing...' : 'Print Selected'}
              </Button>
              {isAdmin && (
                <Button
                  size="sm"
                  className='flex h-10 items-center gap-2 rounded-full bg-[#ef4444] px-3.5 py-2 text-[10px] text-white shadow-[0_10px_24px_rgba(239,68,68,0.22)] hover:bg-[#dc2626]'
                  onClick={onBulkDelete}
                >
                  <TrashIcon className='h-3.5 w-3.5' />
                  Delete Selected
                </Button>
              )}
              <Button
                size="sm"
                className='h-10 rounded-full bg-white px-3.5 py-2 text-[10px] text-slate-700 shadow-none ring-1 ring-slate-200 hover:bg-slate-50'
                onClick={onClearSelection}
              >
                Clear Selection
              </Button>
            </div>
          )}
          <OrderTable fetchAdminOrders={fetchAdminOrders} loadingMore={loadingMore} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} setItemOffset={setItemOffset} setCurrentPage={setCurrentPage} currentPage={currentPage} searchQuery={searchQuery} deleteOrder={deleteOrder} filteredOrderList={filteredOrderList} handlePartnerModal={handlePartnerModal} setOrderID={setOrderID} orderList={orderList} activeTab={activeTab} loadingOrder={loadingOrder} setLoadingOrder={setLoadingOrder} search={search} selectedOrderIds={selectedOrderIds} toggleOrderSelection={toggleOrderSelection} toggleSelectAllVisible={toggleSelectAllVisible} />
        </>
      )}

    </div>
  )
}

export default Orders
